<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { queryIndex } from '~/graphql'
import { useSchemaGraph, buildSchemaWebPage } from '~/composables/schema'
import { schemaIds } from '~/types/schema'

const { resolveSectionComponent } = useResolveComponent()

const { data, error } = await useDatoQuery(queryIndex)

if (!data.value?.index || error.value) {
  console.error(error.value)
}

if (import.meta.env.SSR) {
  useTheme(AppTheme.DARK)
}

onMounted(() => {
  if (import.meta.client) {
    useTheme(AppTheme.DARK)
  }
})

useHead(() => {
  return toHead(data.value?.index?._seoMetaTags || [])
})

const config = useRuntimeConfig()
const { usePageSchema } = useSchemaGraph()
const ids = schemaIds(config.public.appUrl)

usePageSchema([
  buildSchemaWebPage({
    id: ids.WEBSITE.replace('#website', '#webpage'),
    url: config.public.appUrl,
    name: 'Atlas Creative',
    inLanguage: 'en',
    isPartOf: { '@id': ids.WEBSITE }
  })
])
</script>

<template>
  <div v-if="data?.index">
    <component
      :is="resolveSectionComponent(item.__typename as SectionComponents)"
      v-for="(item, index) in data.index.modules"
      :key="item.id"
      :data="item"
      :module-index="index"
      class="relative"
    />
  </div>
</template>
